module.exports = __webpack_public_path__ + "assets/img/options.c0452f12.jpg";